import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { useNavigate } from "react-router-dom";
import SuccessModal from "../../SuccessModal";
import { customerUpdate } from "../../../services/CustomerInfo/EditCustomer";

export default function EditCustomerNameModal({
  editCustomerNameModalVisible,
  setEditCustomerNameModalVisible,
  fieldNameName, // Receive the field name from EditCustomer
  fieldNameValue, // Receive the field value from EditCustomer
  fieldLastNameValue,
  nameEditIcon,
  editCustomerData,
  sendDataToEditCustomer,
  //   handleEditData, // Function to handle edit in EditCustomer
}) {
  const navigate = useNavigate();

  const [editValue, setEditValue] = useState(fieldNameValue);
  const [editLastNameValue, setEditLastNameValue] =
    useState(fieldLastNameValue);

    const handleEditValue = (name) => {
      const copyName = name.replace(/[^A-Za-z0-9\., ]/g, "");
      setEditValue(copyName);
    };

    const handleEditLastNameValue = (name) => {
      const copyName = name.replace(/[^A-Za-z0-9\., ]/g, "");
      setEditLastNameValue(copyName);
    };

  const handleEditData = async () => {
    // Create a new edited field object
    const editedField = {
      fieldNameName: fieldNameName, // Store the field name
      fieldNameValue: editValue, // Store the edited field value
      fieldLastNameValue: editLastNameValue, // Store the edited field value
      customerType: "customerType",
    };

    // Update the specific field in editCustomerData
    let updatedData = { ...editCustomerData };
    if (fieldNameName === "Name") {
      updatedData.brandCustomer.firstName = editValue.replace(/^\s+/, '');
      updatedData.brandCustomer.lastName = editLastNameValue.replace(/\s+$/, '');
      updatedData.brandCustomer.customerType = "customerType";
    }
    // Add more conditions for other fields
    try {
      const response = await customerUpdate(updatedData);
      if (!response.data.error) {
        const Res = response.data;
        const message = Res.message;
        const status = Res.status;

        // Close the modal
        setEditCustomerNameModalVisible(false);
        sendDataToEditCustomer({
          success: true,
        });
        if (status === true) {
          setModalVisible(true);
          setModalStatus("success");
          setModalText(message);
        } else {
          setModalVisible(true);
          setModalStatus("not Success");
          setModalText(message);
        }
        // if (Res) {
        //   sendDataToEditCustomer({
        //     success: true,
        //   });
        // }
      }
    } catch (error) {
      console.error("Error:", error);
    }

    // Close the modal
    setEditCustomerNameModalVisible(false);
  };

  useEffect(() => {
    // When the fieldNameName or fieldNameValue changes, update the editValue
    if (
      fieldNameName !== null &&
      fieldNameValue !== null &&
      fieldLastNameValue !== null
    ) {
      setEditValue(fieldNameValue);
      setEditLastNameValue(fieldLastNameValue);
    }
  }, [fieldNameName, fieldNameValue, fieldLastNameValue]);

  //         //

  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");

  const handleModalClose = () => {
    setEditCustomerNameModalVisible(false);
    // setEditValue
    // setEditLastNameValue
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={editCustomerNameModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!editCustomerNameModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-4 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <i
                className="pi pi-user"
                style={{ fontSize: "50px", color: "#fff" }}
              ></i>
              <p className=" text-4xl text-primary-50 font-semibold">
                Edit Name
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
              ></Button>
            </div>
            <div className="inline-flex flex-column gap-2 mx-4">
              <p className=" font-semibold">First Name</p>
              <InputText
                value={editValue}
                onChange={(e) => handleEditValue(e.target.value)}
                id="firstName"
                label="firstName"
                placeholder="Enter First Name"
                className="w-full bg-white-alpha-20 p-2 border-round-xl text-xl "
              ></InputText>
            </div>
            <div className="inline-flex flex-column gap-2 mx-4">
              <p className=" font-semibold">Last Name</p>
              <InputText
                value={editLastNameValue}
                onChange={(e) => handleEditLastNameValue(e.target.value)}
                id="lastName"
                label="lastName"
                placeholder="Enter Last Name"
                className="w-full bg-white-alpha-20 p-2 border-round-xl text-xl "
              ></InputText>
            </div>

            <Button
              onClick={handleEditData}
              className="mt-1 mb-3 mx-4 border-round-xl "
            >
              <p className=" w-full text-2xl font-semibold flex justify-content-center">
                Submit
              </p>
            </Button>
          </div>
        )}
      ></Dialog>
      <div>
        <SuccessModal
          modalVisible={modalVisible}
          setModalVisible={setModalVisible}
          status={modalStatus}
          text={modalText}
        />
      </div>
    </div>
  );
}
